interface HeaderInterface {
    'custom-host': string
}

export default class RequestInfo {
    constructor() {}

    static header: HeaderInterface = null

    static setHeader(header: HeaderInterface) {
        RequestInfo.header = header
    }
}